import { Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../models/response.model'
@Injectable({
  providedIn: 'root',
})
export class AdminService {
  private baseUrl = environment.baseUrl
  private resource: string = 'administrador'

  constructor(private httpClient: HttpClient) {}

  public createAdmin(
    model: any,
    // model: CreateLegalEntityClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editAdmin(
    model: any,
    // model: EditLegalEntityClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.put<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/update`,
      model,
    )
  }

  public deleteLegalEntityClient(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public listPagedAdmin(
    page: number,
    rows: number = 10,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/paginated?page=${page}&per_page=${rows}`,
    )
  }

  public listPagedLegalEntityClientBySubClientId(
    subClientId: number,
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/associado-subcliente/${subClientId}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedNotLegalEntityClientBySubClientId(
    subClientId: number,
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/desassociado-subcliente/${subClientId}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listMedic(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/list`,
    )
  }

  public getLegalEntityClientbyId(
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedAdmin(
    page: number,
    rows: number = 10,
    model: any,
  ): Observable<ResponseRequestModel> {
    if(model.nome_principal === undefined){
      model.nome_principal = ""
    }
    if(model.cpf === undefined){
      model.cpf = ""
    }
    if(model.cnpj === undefined){
      model.cnpj = ""
    }
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/paginated?page=${page}&per_page=${rows}&nome=${model.nome_principal}&cpf=${model.cpf}&cnpj=${model.cnpj}`,
    )
  }

  public searchPagedLegalEntityClientAssociateBySubClient(
    page: number,
    rows: number = 15,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated/associado-subcliente?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
